'use client'

import { createContext, use } from 'react'

import { type TabsListVariant } from '~/components/component-library/Tabs/types'

export const TabsListVariantContext = createContext<TabsListVariant>('default')

export const useTabsListVariant = () => use(TabsListVariantContext)

type TabsValue = { value: string; onValueChange: (value: string) => void }

export const TabsValueContext = createContext<TabsValue>({
  value: '',
  onValueChange: () => {},
})

export const useTabsValue = () => use(TabsValueContext)

/** Where a TabsTrigger is rendering: the tab row, a dropdown option, or the dropdown's label */
type TabsTriggerRenderMode = 'tab' | 'option' | 'label'

export const TabsTriggerRenderContext =
  createContext<TabsTriggerRenderMode>('tab')

export const useTabsTriggerRenderMode = () => use(TabsTriggerRenderContext)
